export default "__VITE_ASSET__t1lvTWiB__"